export const GOOGLE_MAP_API = process.env.REACT_APP_GOOGLE_MAPS;
